"use strict";
// N.B. This file is used on both the front-end and back-end. Do not import or
// use node-specific libraries.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallStatus = exports.LogMessageCategory = exports.SELECTIZE_DROPDOWN_HIDDEN_OPTION_VALUE = exports.SELECTIZE_DROPDOWN_CUSTOM_ACTION_EVENT_NAME = exports.EMAIL_REGEX = exports.IncomingDestination = exports.DialerClientDestination = exports.LiveListenAction = exports.WaitingRoomAction = exports.SiphonHook = exports.WEBHOOK_PREFIX = exports.Position = exports.UnreachableError = exports.ErrorWithStatus = void 0;
exports.isValidLogMessageLevel = isValidLogMessageLevel;
exports.pad = pad;
exports.formatNameAndLastInitial = formatNameAndLastInitial;
exports.isEnumValue = isEnumValue;
exports.assertIsEnumValue = assertIsEnumValue;
exports.objectEntries = objectEntries;
exports.objectKeys = objectKeys;
exports.definedObjectValues = definedObjectValues;
exports.isObjectKey = isObjectKey;
exports.pickValueOrDefault = pickValueOrDefault;
exports.assertArrayOf = assertArrayOf;
exports.tryParseJSON = tryParseJSON;
exports.isNotNullOrUndefined = isNotNullOrUndefined;
class ErrorWithStatus extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}
exports.ErrorWithStatus = ErrorWithStatus;
/**
 * Error for unexpected values in exhaustive checks.
 * *
 * ⚠️ Do **not** use this for values crossing service boundaries
 * (e.g., frontend/backend enums). For instance, on the frontend, prefer
 * {@link neverTabby}, which logs the unexpected value but lets the caller
 * decide how to handle it safely.
 */
class UnreachableError extends Error {
    constructor(label, value) {
        super(`Unexpected ${label}: ${JSON.stringify(value)}`);
    }
}
exports.UnreachableError = UnreachableError;
var Position;
(function (Position) {
    Position[Position["LEFT"] = 0] = "LEFT";
    Position[Position["RIGHT"] = 1] = "RIGHT";
})(Position || (exports.Position = Position = {}));
exports.WEBHOOK_PREFIX = "/webhook";
var SiphonHook;
(function (SiphonHook) {
    SiphonHook["INCOMING"] = "/incoming";
    SiphonHook["INCOMING_JOIN"] = "/incoming-join";
    SiphonHook["INCOMING_PAUSED"] = "/incoming-paused";
    SiphonHook["INCOMING_FINISHED"] = "/incoming-finished";
    SiphonHook["INCOMING_EVENT"] = "/incoming-event";
    SiphonHook["INCOMING_EVENT_CONFERENCE"] = "/incoming-event-conference";
    SiphonHook["INCOMING_EVENT_SALESFLOOR"] = "/incoming-event-salesfloor";
    SiphonHook["PRERECORDING"] = "/prerecording";
    SiphonHook["PRERECORDING_RECORDING"] = "/prerecording-recording";
    SiphonHook["PRERECORDING_STORED"] = "/prerecording-stored";
    SiphonHook["PRERECORDING_OPTIONS"] = "/prerecording-options";
    SiphonHook["VERIFY_USER_PHONE_NUMBER"] = "/verify-user-phone-number";
    SiphonHook["CALLBACK_VERIFY"] = "/callback-verify";
    SiphonHook["USER_EVENT"] = "/user-event";
    SiphonHook["OUT_OF_DIALS"] = "/out-of-dials";
    SiphonHook["MORE_TRAVERSAL_DATA"] = "/more-traversal-data";
    SiphonHook["EAVESDROP_STARTED"] = "/eavesdrop-started";
    SiphonHook["EAVESDROP_FINISHED"] = "/eavesdrop-finished";
    SiphonHook["PREPARE_CALLBACK"] = "/prepare-callback";
    SiphonHook["REP_CALLBACK_PHONE"] = "/rep-callback-phone";
    SiphonHook["REP_CONFERENCE_CALLBACK_PHONE"] = "/rep-callback-phone-conference";
    SiphonHook["MAKE_TARGETED_CALL"] = "/make-targeted-call";
    SiphonHook["CALL_SINGLE_ENTRY_FROM_DIALER"] = "/make-targeted-call-from-dialer";
    SiphonHook["PLAY_NICE_SELECTED_ORUM_VOICE"] = "/play-nice-selected-orum-voice";
    SiphonHook["ADD_PARTY_TO_CALL_FINISHED"] = "/add-party-to-call-finished";
})(SiphonHook || (exports.SiphonHook = SiphonHook = {}));
var WaitingRoomAction;
(function (WaitingRoomAction) {
    WaitingRoomAction["TOGGLE_ALTERNATE"] = "toggleAlternate";
    WaitingRoomAction["PREPARE_DIAL_IN_BROWSER"] = "prepareDialInBrowser";
})(WaitingRoomAction || (exports.WaitingRoomAction = WaitingRoomAction = {}));
var LiveListenAction;
(function (LiveListenAction) {
    LiveListenAction["END_LISTENING_SESSION"] = "endListeningSession";
})(LiveListenAction || (exports.LiveListenAction = LiveListenAction = {}));
var DialerClientDestination;
(function (DialerClientDestination) {
    DialerClientDestination["WAITING_ROOM_BROWSER"] = "waiting_room_browser";
    DialerClientDestination["SALESFLOOR"] = "salesfloor";
})(DialerClientDestination || (exports.DialerClientDestination = DialerClientDestination = {}));
var IncomingDestination;
(function (IncomingDestination) {
    IncomingDestination["WAITING_ROOM_PHONE"] = "waiting_room";
    // N.B. Demo numbers MUST begin with demo_. See inbound.xml for the regex.
    IncomingDestination["DEMO_HUMAN"] = "demo_human";
    IncomingDestination["DEMO_GEORGE"] = "demo_george";
    IncomingDestination["DEMO_JOHN"] = "demo_john";
    IncomingDestination["DEMO_VOICEMAIL"] = "demo_voicemail";
    IncomingDestination["DEMO_DIAL_TREE"] = "demo_dial_tree";
    IncomingDestination["DEMO_DIAL_TREE_ABC"] = "demo_dial_tree_abc";
    IncomingDestination["DEMO_CONTACT"] = "demo_contact";
    IncomingDestination["DEMO_HANGUP"] = "demo_hangup";
    IncomingDestination["DEMO_CAPTCHA"] = "demo_captcha";
    IncomingDestination["DEMO_EXTENSION"] = "demo_extension";
    IncomingDestination["DEMO_APPLE_SCREENER_ACCEPTED"] = "demo_apple_screener_accepted";
    IncomingDestination["DEMO_APPLE_SCREENER_REJECTED"] = "demo_apple_screener_rejected";
    IncomingDestination["DEMO_GOOGLE_SCREENER_ACCEPTED"] = "demo_google_screener_accepted";
    IncomingDestination["DEMO_GOOGLE_SCREENER_REJECTED"] = "demo_google_screener_rejected";
    IncomingDestination["DEMO_JA_JP_IDOL"] = "demo_ja_jp_idol";
    IncomingDestination["DEMO_JA_JP_SONGS"] = "demo_ja_jp_songs";
    IncomingDestination["DEMO_JA_JP_VOICEMAIL"] = "demo_ja_jp_voicemail";
    IncomingDestination["DEMO_JA_JP_HUMAN"] = "demo_ja_jp_human";
    IncomingDestination["DEMO_JA_JP_CONTACT"] = "demo_ja_jp_contact";
    IncomingDestination["DEMO_ES_US_VOICEMAIL"] = "demo_es_us_voicemail";
    IncomingDestination["DEMO_ES_US_HUMAN"] = "demo_es_us_human";
    IncomingDestination["DEMO_ES_US_CONTACT"] = "demo_es_us_contact";
    IncomingDestination["DEMO_ES_ES_VOICEMAIL"] = "demo_es_es_voicemail";
    IncomingDestination["DEMO_ES_ES_HUMAN"] = "demo_es_es_human";
    IncomingDestination["DEMO_ES_ES_CONTACT"] = "demo_es_es_contact";
    IncomingDestination["DEMO_ES_STORYTIME"] = "demo_es_storytime";
    IncomingDestination["DEMO_ES_OBJECTION"] = "demo_es_objection";
    IncomingDestination["DEMO_PT_BR_VOICEMAIL"] = "demo_pt_br_voicemail";
    IncomingDestination["DEMO_PT_BR_HUMAN"] = "demo_pt_br_human";
    IncomingDestination["DEMO_PT_BR_CONTACT"] = "demo_pt_br_contact";
    IncomingDestination["DEMO_PT_PT_VOICEMAIL"] = "demo_pt_pt_voicemail";
    IncomingDestination["DEMO_PT_PT_HUMAN"] = "demo_pt_pt_human";
    IncomingDestination["DEMO_PT_PT_CONTACT"] = "demo_pt_pt_contact";
    IncomingDestination["DEMO_DE_DE_VOICEMAIL"] = "demo_de_de_voicemail";
    IncomingDestination["DEMO_DE_DE_HUMAN"] = "demo_de_de_human";
    IncomingDestination["DEMO_DE_DE_CONTACT"] = "demo_de_de_contact";
    IncomingDestination["DEMO_NL_NL_VOICEMAIL"] = "demo_nl_nl_voicemail";
    IncomingDestination["DEMO_NL_NL_HUMAN"] = "demo_nl_nl_human";
    IncomingDestination["DEMO_NL_NL_CONTACT"] = "demo_nl_nl_contact";
    IncomingDestination["DEMO_FR_CA_VOICEMAIL"] = "demo_fr_ca_voicemail";
    IncomingDestination["DEMO_FR_CA_HUMAN"] = "demo_fr_ca_human";
    IncomingDestination["DEMO_FR_CA_CONTACT"] = "demo_fr_ca_contact";
    IncomingDestination["DEMO_FR_FR_VOICEMAIL"] = "demo_fr_fr_voicemail";
    IncomingDestination["DEMO_FR_FR_HUMAN"] = "demo_fr_fr_human";
    IncomingDestination["DEMO_FR_FR_CONTACT"] = "demo_fr_fr_contact";
    IncomingDestination["DEMO_SV_SE_VOICEMAIL"] = "demo_sv_se_voicemail";
    IncomingDestination["DEMO_SV_SE_HUMAN"] = "demo_sv_se_human";
    IncomingDestination["DEMO_SV_SE_CONTACT"] = "demo_sv_se_contact";
    IncomingDestination["DEMO_DA_DK_VOICEMAIL"] = "demo_da_dk_voicemail";
    IncomingDestination["DEMO_DA_DK_HUMAN"] = "demo_da_dk_human";
    IncomingDestination["DEMO_DA_DK_CONTACT"] = "demo_da_dk_contact";
    IncomingDestination["DEMO_FI_FI_VOICEMAIL"] = "demo_fi_fi_voicemail";
    IncomingDestination["DEMO_FI_FI_HUMAN"] = "demo_fi_fi_human";
    IncomingDestination["DEMO_FI_FI_CONTACT"] = "demo_fi_fi_contact";
    IncomingDestination["DEMO_NB_NO_VOICEMAIL"] = "demo_nb_no_voicemail";
    IncomingDestination["DEMO_NB_NO_HUMAN"] = "demo_nb_no_human";
    IncomingDestination["DEMO_NB_NO_CONTACT"] = "demo_nb_no_contact";
    IncomingDestination["DEMO_HE_IL_VOICEMAIL"] = "demo_he_il_voicemail";
    IncomingDestination["DEMO_HE_IL_HUMAN"] = "demo_he_il_human";
    IncomingDestination["DEMO_HE_IL_CONTACT"] = "demo_he_il_contact";
    IncomingDestination["DEMO_IT_IT_VOICEMAIL"] = "demo_it_it_voicemail";
    IncomingDestination["DEMO_IT_IT_HUMAN"] = "demo_it_it_human";
    IncomingDestination["DEMO_IT_IT_CONTACT"] = "demo_it_it_contact";
    IncomingDestination["DEMO_HI_IN_VOICEMAIL"] = "demo_hi_in_voicemail";
    IncomingDestination["DEMO_HI_IN_HUMAN"] = "demo_hi_in_human";
    IncomingDestination["DEMO_HI_IN_CONTACT"] = "demo_hi_in_contact";
    IncomingDestination["DEMO_AR_XA_VOICEMAIL"] = "demo_ar_xa_voicemail";
    IncomingDestination["DEMO_AR_XA_HUMAN"] = "demo_ar_xa_human";
    IncomingDestination["DEMO_AR_XA_CONTACT"] = "demo_ar_xa_contact";
})(IncomingDestination || (exports.IncomingDestination = IncomingDestination = {}));
// N.B. All allowed characters referenced here: https://www.ietf.org/rfc/rfc3696.txt
exports.EMAIL_REGEX = /^[A-Z0-9'._%+-]+@[A-Z0-9.-]+\.[A-Z0-9]{2,}$/i;
exports.SELECTIZE_DROPDOWN_CUSTOM_ACTION_EVENT_NAME = "CUSTOM_ACTION";
exports.SELECTIZE_DROPDOWN_HIDDEN_OPTION_VALUE = "HIDDEN_OPTION";
// These categories may be used by both browser and server loggers.
var LogMessageCategory;
(function (LogMessageCategory) {
    LogMessageCategory["AUTH_STRATEGY_CALLBACK_CONFLICT"] = "auth_strategy_callback_conflict";
    LogMessageCategory["BEEP_TRACING"] = "beep_tracing";
    LogMessageCategory["CALL_HISTORY"] = "call_history";
    LogMessageCategory["CALL_LOGGING_CONFIRMATION"] = "call_logging_confirmation";
    LogMessageCategory["DEPLOY"] = "deploy";
    LogMessageCategory["DIALER"] = "dialer";
    LogMessageCategory["DIALER_V2"] = "dialer_v2";
    LogMessageCategory["FETCH_LIST_RESULTS"] = "fetch_list_results";
    LogMessageCategory["LOCKED_FETCH_ENTRIES"] = "locked_fetch_entries";
    LogMessageCategory["HANGOUTS"] = "hangouts";
    LogMessageCategory["SAPI"] = "sapi";
    LogMessageCategory["SIP_JS"] = "sip_js";
    LogMessageCategory["PIPL"] = "pipl";
    LogMessageCategory["SIPHON_CALL_SESSION"] = "siphon_call_session";
    LogMessageCategory["GENERAL"] = "general";
    LogMessageCategory["CRON_JOBS"] = "cron_jobs";
    LogMessageCategory["AI_CHATBOT"] = "ai_chatbot";
    LogMessageCategory["ZOD_VALIDATOR"] = "zod_validator";
    LogMessageCategory["CONTENT_GENERATION"] = "content_generation";
    LogMessageCategory["DATA_ENRICHMENT"] = "data_enrichment";
    LogMessageCategory["KNOCK"] = "knock";
    LogMessageCategory["SLACK_ALERTS"] = "slack_alerts";
    LogMessageCategory["REDIS"] = "redis";
    LogMessageCategory["MESSAGE_QUEUE"] = "message_queue";
    LogMessageCategory["STATSIG"] = "statsig";
    LogMessageCategory["QUERY_MONITORING"] = "query_monitoring";
    // Pulse
    LogMessageCategory["RECALL"] = "recall";
    LogMessageCategory["PULSE_ROLEPLAY"] = "pulse_roleplay";
    // Remove this once PD-5862 is resolved.
    LogMessageCategory["ROOM_DIALING_CONNECTED_NULL_CALL_SID"] = "room_dialing_connected_null_call_sid";
})(LogMessageCategory || (exports.LogMessageCategory = LogMessageCategory = {}));
function isValidLogMessageLevel(logLevel, validLogLevels) {
    return validLogLevels.includes(logLevel);
}
function pad(n) {
    if (n < 10)
        return `0${n}`;
    return String(n);
}
function formatNameAndLastInitial(name) {
    const names = name.split(" ");
    if (names.length === 0)
        return "";
    if (names.length === 1)
        return name;
    const firstName = names[0];
    const lastName = names[names.length - 1];
    if (lastName.length > 0)
        return `${firstName} ${lastName[0]}.`;
    return firstName;
}
function isEnumValue(enumObj, value) {
    return Object.values(enumObj).includes(value);
}
function assertIsEnumValue(enumObj, value) {
    if (!isEnumValue(enumObj, value)) {
        throw new RangeError(`Expected "${value}" to be a valid enum value. Valid values: ${Object.values(enumObj)}`);
    }
}
function objectEntries(obj) {
    return Object.entries(obj);
}
function objectKeys(obj) {
    return Object.keys(obj);
}
function definedObjectValues(obj) {
    return Object.values(obj).filter((v) => v !== undefined);
}
function isObjectKey(object, key) {
    return Object.keys(object).includes(String(key));
}
var CallStatus;
(function (CallStatus) {
    CallStatus["STARTED"] = "started";
    CallStatus["ANSWERED"] = "answered";
    CallStatus["COMPLETED"] = "completed";
    CallStatus["BUSY"] = "busy";
    CallStatus["FAILED"] = "failed";
    CallStatus["CANCELLED"] = "cancelled";
    CallStatus["FAILED_SIPHON_ERROR"] = "failed-siphon-error";
})(CallStatus || (exports.CallStatus = CallStatus = {}));
function pickValueOrDefault(value, defaultValue) {
    return value === undefined ? defaultValue : value;
}
function assertArrayOf(x, assertionFunction) {
    for (const y of x) {
        assertionFunction(y);
    }
}
function tryParseJSON(json) {
    try {
        return JSON.parse(json);
    }
    catch {
        return null;
    }
}
function isNotNullOrUndefined(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=common.js.map